import { useCallback, useEffect, useRef, useState } from "react";
import { MessageSquare } from "lucide-react";
import clienteApi from "../../lib/clienteApi";
import { playDing } from "../../lib/notifySound";

const readSeen = (key) => { try { return JSON.parse(localStorage.getItem(key) || "[]"); } catch (e) { return []; } };

export const ClienteNewMessagePopup = ({ userId, onOpen }) => {
  const [queue, setQueue] = useState([]);
  const seenKey = `pgp_cli_msg_notified_${userId}`;

  const known = useRef(new Set());

  const poll = useCallback(() => {
    clienteApi.get("/cliente/messaggi/unread").then(({ data }) => {
      const seen = new Set(readSeen(seenKey));
      const fresh = data.filter((m) => !seen.has(m.id) && !known.current.has(m.id));
      if (!fresh.length) return;
      fresh.forEach((m) => known.current.add(m.id));
      playDing();
      setQueue((q) => [...q, ...fresh]);
    }).catch(() => {});
  }, [seenKey]);

  useEffect(() => {
    if (!userId) return;
    poll();
    const id = setInterval(poll, 30000);
    return () => clearInterval(id);
  }, [userId, poll]);

  const current = queue[0];
  if (!current) return null;
  const markSeen = (ids) => localStorage.setItem(seenKey, JSON.stringify([...readSeen(seenKey), ...ids].slice(-500)));
  const later = () => { markSeen([current.id]); setQueue((q) => q.slice(1)); };
  const openNow = () => {
    const same = queue.filter((m) => m.pratica_id === current.pratica_id);
    markSeen(same.map((m) => m.id));
    setQueue((q) => q.filter((m) => m.pratica_id !== current.pratica_id));
    onOpen(current.pratica_id);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4" data-testid="cliente-new-message-popup">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl pgp-fade-up">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 shrink-0 rounded-full bg-[#F3F4F6] flex items-center justify-center">
            <MessageSquare className="h-5 w-5 text-[#111827]" />
          </div>
          <p className="text-base font-semibold text-[#111827]" data-testid="cliente-new-message-text">Nuovo messaggio dal tuo studio</p>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={later} data-testid="cliente-new-message-later"
            className="rounded-lg border border-[#d1d5db] px-4 py-2 text-sm font-medium text-[#111827] hover:bg-[#F3F4F6] transition-colors">Vedi dopo</button>
          <button type="button" onClick={openNow} data-testid="cliente-new-message-open"
            className="rounded-lg bg-[#9a3412] px-4 py-2 text-sm font-semibold text-[#ffffff] hover:bg-[#7c2d12] transition-colors">Vedi subito</button>
        </div>
      </div>
    </div>
  );
};
